module.exports = __webpack_public_path__ + "img/AQ.a123705f.svg";